<template>
  <b-table :striped="striped" :bordered="bordered" :borderless="borderless" :outlined="outlined" :small="small" :hover="hover" :dark="dark" :fixed="fixed" :foot-clone="footClone" :no-border-collapse="noCollapse" :items="items" :fields="fields" :head-variant="headVariant" :table-variant="tableVariant"></b-table>
</template>

<script>
import "../../assets/scss/table.scss";

export default {
  name: "my-table",
  data() {
    return {};
  },
  created() {},
  methods: {},
  props: {
    striped: {
      default: false,
    },
    bordered: {
      default: false,
    },
    borderless: {
      default: false,
    },
    outlined: {
      default: false,
    },
    small: {
      default: false,
    },
    hover: {
      default: false,
    },
    dark: {
      default: false,
    },
    fixed: {
      default: false,
    },
    footClone: {
      default: false,
    },
    headVariant: {
      default: null,
    },
    tableVariant: {
      default: "",
    },
    noCollapse: {
      default: false,
    },

    items: { required: true },
    fields: { required: true },
  },
};
</script>
